class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      searchQuery: "[data-query]",
      searchMessage: "[data-message]",
      input: "[data-search-input]",
      submit: 'button[type="submit"]',
      loading: "[data-spinner]",
      popularSearchItems: ["[data-ps-item]"],
      moreResultIcon: "[data-more-result-icon]",
    };

    this.container = document.querySelector("[data-search-popup]");
this.overlay = this.querySelector(".search-overlay");
if (this.overlay && this.overlay.parentElement !== document.body) {
  document.body.appendChild(this.overlay);
}
this.handleOutsideClick =
  this.handleOutsideClick.bind(this);

this.handleEscapeKey =
  this.handleEscapeKey.bind(this);
    // DOM nodes
    this.input = this.querySelector(this.selectors.input);
    this.submit = this.querySelector(this.selectors.submit);
    this.loading = this.querySelector(this.selectors.loading);
    this.clear = this.querySelector("[data-clear-search]");
    this.popularSearchItems = this.querySelectorAll(this.selectors.popularSearchItems);
    this.searchQuery = this.querySelector(this.selectors.searchQuery);
    this.searchMessage = this.querySelector(this.selectors.searchMessage);
    this.moreResultIcon = this.querySelector(this.selectors.moreResultIcon);

    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.searchPopupSearults = this.querySelector(".m-search-popup__result");
    this.popularSearches = this.querySelector("[data-popular-searches]");
    this.searchCount = this.querySelector("[data-search-count]");

    this.cachedResults = {};
    this.transitionDuration = 300;
    this.abortController = null;
    this.isOpen = false;

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector("form.m-search-form");
    if (form) form.addEventListener("submit", this.onFormSubmit.bind(this));
    if (this.input) this.input.addEventListener("input", this.onChange.bind(this));
    if (this.clear) this.clear.addEventListener("click", this.onClearSearch.bind(this));
document.addEventListener(
  "pointerdown",
  this.handleOutsideClick
);

document.addEventListener(
  "keydown",
  this.handleEscapeKey
);
this.overlay?.addEventListener(
  "pointerdown",
  () => this.close()
);
    if (typeof MinimogEvents !== 'undefined' && MinimogEvents.subscribe) {
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.closeSearchPopup, () => this.close(true));
    }
  }

  getQuery() {
    return this.input?.value.trim() || "";
  }

  onChange() {
    const searchTerm = this.getQuery();

    // Show "x" dynamically when user types
    if (this.clear) this.clear.style.display = searchTerm.length > 0 ? "inline-flex" : "none";

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
      event.preventDefault();
    }
  }

  onClearSearch(event) {
    event.preventDefault();
    if (!this.input) return;

    this.input.value = "";
    this.close(true);                 // hide dropdown & results
    if (this.clear) this.clear.style.display = "none";  // hide "x"
  }
  handleEscapeKey(event) {
  if (event.key === "Escape" && this.isOpen) {
    this.close();
  }
}

handleOutsideClick(event) {
  if (!this.isOpen) return;

  if (this.contains(event.target)) {
    return;
  }

  this.close();
}

  toggleSpinnerLoading(show) {
    if (this.submit) this.submit.style.visibility = show ? "hidden" : "visible";
    if (this.loading) this.loading.style.visibility = show ? "visible" : "hidden";
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(/\s+/g, "-").toLowerCase();
    this.toggleSpinnerLoading(true);

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    let searchFields = "title,product_type,vendor,variants.sku,variants.title";
    if (this.dataset.searchByTag === "true") searchFields += ",body";
    if (this.dataset.searchByBody === "true") searchFields += ",tag";

    const unavailableProductsOption = this.dataset.unavailableProductsOption;

    const searchURL = `${window.MinimogSettings.routes.predictive_search_url}?q=${encodeURIComponent(
      searchTerm
    )}&resources[options][unavailable_products]=${unavailableProductsOption}&resources[options][fields]=${searchFields}&section_id=predictive-search`;

    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    fetch(searchURL, { signal: this.abortController.signal })
      .then(res => {
        if (!res.ok) {
          this.close();
          throw new Error(res.status);
        }
        return res.text();
      })
      .then(text => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch(error => {
        if (error.name === 'AbortError') return;
        this.close();
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
  if (!this.predictiveSearchResults) return;

  this.predictiveSearchResults.innerHTML = resultsMarkup;
  this.setAttribute("results", true);

  // Re-query after innerHTML swap since these now live inside the rendered markup
  this.searchQuery = this.querySelector(this.selectors.searchQuery);
  this.searchMessage = this.querySelector(this.selectors.searchMessage);
  this.searchCount = this.querySelector("[data-search-count]");
  this.moreResultIcon = this.querySelector(this.selectors.moreResultIcon);

  const searchItemsWrapper = this.querySelector("[data-search-items-wrapper]");
  this.renderSearchQueryAndMessage(searchItemsWrapper?.childElementCount > 0);

  this.toggleSpinnerLoading(false);
  if (this.clear) this.clear.style.display = this.getQuery().length > 0 ? "inline-flex" : "none";
  this.open();
}

  renderSearchQueryAndMessage(results) {
    if (!this.input || !this.searchQuery || !this.searchMessage) return;

    this.searchQuery.textContent = this.input.value;

    if (results) {
      this.searchMessage.textContent = this.searchMessage.dataset.resultsTitle || "";
      this.moreResultIcon?.classList.add("m:hidden");
    } else {
      this.searchMessage.textContent = this.searchMessage.dataset.resultsTitle || "";
      this.moreResultIcon?.classList.remove("m:hidden");
    }

    this.predictiveSearchResults.classList.remove("m:hidden");
    this.searchPopupSearults.classList.remove("m:hidden");
  }

  open() {
    if (!this.searchPopupSearults) return;

    this.searchPopupSearults.style.setProperty(
      "--search-result-max-height",
      `${this.resultsMaxHeight || this.getResultsMaxHeight()}px`
    );

    this.setAttribute("open", true);
    this.input?.setAttribute("aria-expanded", true);
    document.body.classList.add(
  "search-open"
);

this.overlay?.classList.add(
  "is-active"
);
    this.isOpen = true;

    this.popularSearches?.classList.add("m:hidden");
    this.searchCount?.classList.remove("m:hidden");
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm && this.input) {
      this.input.value = "";
      this.removeAttribute("results");
      if (this.clear) this.clear.style.display = "none";
      this.resultsMaxHeight = false;
    }

    this.removeAttribute("open");
    this.predictiveSearchResults?.classList.add("m:hidden");
    this.searchPopupSearults?.classList.add("m:hidden");
    this.popularSearches?.classList.remove("m:hidden");
    this.searchCount?.classList.add("m:hidden");
    document.body.classList.remove(
  "search-open"
);

this.overlay?.classList.remove(
  "is-active"
);

this.isOpen = false;
  }
  

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - this.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
}

customElements.define("predictive-search", PredictiveSearch);
